import axiosApiInstance from '../../interceptors/axiosApiInstance';
import { BASE_URL } from '../config';

const ModuleService = {
    getModules: async function () {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + '/module/library');
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    }
};
export default ModuleService;
